import { createSelector } from "@ngrx/store";
import { AppStateInterface } from "../../appState.interface";

export const selectFeature = (state: AppStateInterface) => state.currentEmployee;

export const isLoadingSelector = createSelector(
    selectFeature, 
    (state) => state.isLoading
);

export const currentEmployeeSelector = createSelector(
    selectFeature, 
    (state) => state.currentEmployee
);

export const errorSelector = createSelector(
    selectFeature, 
    (state) => state.error
);